import { Component, OnInit, ViewChild, AfterViewInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { CommonMapComponent, MapParamsConfig } from 'app/components/common-map/common-map.component';
import { LRSMap } from 'assets/TS/LRSMap_New';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { MainDataMapLayersService } from 'app/services/main-data-map-layers.service';
import { MapSharedService } from 'app/services/map-shared.service';

@Component({
  selector: 'app-main-data-map',
  templateUrl: './main-data-map.component.html',
  styleUrls: ['./main-data-map.component.css']
})
export class MainDataMapComponent implements OnInit, AfterViewInit, OnDestroy {

	@ViewChild('dataMap', { static: false }) mapComponent: CommonMapComponent;

	// @Input() onDataSelect: Function;
	// @Input() dataSelectCondition: Function;
	@Output() onMapContextmenu: EventEmitter<any> = new EventEmitter();

	readonly mapElemId = 'data-map';
	readonly bgTooltipElemId = 'map-background-tooltip';

	labelContainerId: string;

	mapParamsConfig: MapParamsConfig;;

	_map: LRSMap.Map;

	constructor(
		private mapService: MainDataMapService,
		private mapLayersService: MainDataMapLayersService,
		private mapSharedService: MapSharedService
	) { }

	onContextmenu = (e) => {
		this.onMapContextmenu.emit(e);
	}

	private _initLayers() {
		let zIndex = 0;
		this.mapLayersService.addBgOptionalBdryLayer(this._map, zIndex++);
		this.mapLayersService.addRefVectorTileLayer(this._map, zIndex++);
		this.mapLayersService.addBgSurroundingsLayer(this._map, zIndex++);
		this.mapLayersService.addBgReferenceLayer(this._map, zIndex++);
		// For matchpoint use
		this.mapLayersService.addBgReferenceCountyBdryLayer(this._map, zIndex++, zIndex++); 
		//
		this.mapLayersService.addDataLayer(this._map, zIndex++);
		// this.mapLayersService.addFishboneLayer(this._map, zIndex++);
		this.mapLayersService.addInteractiveFishboneLayer(this._map, zIndex++);

		this.mapLayersService.addTopojsonLayer(this._map, zIndex++);
		this.mapLayersService.addTopologyErrorLayer(this._map, zIndex++);
		this.mapLayersService.addTopologyResolvedLayer(this._map, zIndex++);
		this.mapLayersService.addAddPolygonTempLayer(this._map, zIndex++);
		
		this.mapLayersService.addQcErrorLayer(this._map, zIndex++);
		this.mapLayersService.addFlashLayer(this._map, zIndex++);
		this.mapLayersService.addCursorLayer(this._map, zIndex++);
		this.mapLayersService.addDataModifyLayer(this._map, zIndex++);
		this.mapLayersService.addPlaceMarkerLayer(this._map, zIndex++);
	}

	ngOnInit() {
		this.labelContainerId = this.mapService.labelContainerId;
		this.mapParamsConfig = {
			minReso: this.mapSharedService.minReso,
			center: this.mapSharedService.mapViewCenter,
			reso: this.mapSharedService.mapViewReso,
			minZoomLevel: this.mapSharedService.minZoomLevel
		};
	}
	ngAfterViewInit() {
		this._map = this.mapComponent.map;
		this.mapService.map = this._map;
		this.mapService.mapBS.next(this._map);

		this._initLayers();

		this._map.baseMapLayerGroup.setOpacity(this.mapSharedService.initBasemapOpacity);
	}
	ngOnDestroy(): void {
	}
}
